<template>
  <section v-if="isVisible" :id="uid" class="max-w-screen-xxl mx-auto px-2 mt-3 mb-5">
    <template v-if="isFDPNonBomSpecs">
      <template v-if="!isLoadingSpecs">
        <ul>
          <component
            :is="getComponentForType(component.typeCode)"
            v-for="component of components"
            :key="component.uid"
            :component-data="component"
            :product="product"
          />
        </ul>
      </template>
      <pdl-skeleton v-else is-list :list-count="6" height="15rem" />
    </template>
    <template v-else>
      <ul>
        <slot name="components" />
      </ul>
    </template>

    <!-- Trek disclaimers -->
    <p class="mt-2 mb-1">{{ disclaimerMessage }}</p>
    <p class="mb-1">{{ weightMessage }}</p>
  </section>
</template>

<script>
import {computed} from 'vue';
import {mapState, mapGetters, mapMutations} from 'vuex';
import {PdlSkeleton} from '@pedal/pdl-skeleton';
import {getComponentForType} from '@/modules/CmsComponentMapper.js';
import CmsApi from '@/api/cms';

export default {
  components: {
    PdlSkeleton,
  },
  props: {
    uid: {
      type: String,
      default: undefined,
    },
    componentData: {
      type: Object,
      default: () => null,
    },
  },
  setup(_, {slots}) {
    const isJspSlots = computed(() => {
      return !!Object.keys(slots)?.length;
    });
    return {
      isJspSlots: isJspSlots.value,
    };
  },
  data() {
    return {
      getComponentForType: getComponentForType,
      components: [],
      isLoadingSpecs: true,
    };
  },
  computed: {
    ...mapState('backend', ['b2b']),
    ...mapState('productDetails', ['isBike', 'product', 'productSpecs']),
    ...mapGetters('familyDetails', ['isFDP']),
    ...mapGetters('backend', ['occUrlParams']),

    isVisible() {
      return this.isJspSlots || this.isFDPNonBomSpecs;
    },
    isFDPNonBomSpecs() {
      return !this.isJspSlots && !this.isSpecItem && this.hasComponentData;
    },
    isSpecItem() {
      return this.product?.useSpecItem;
    },
    hasComponentData() {
      if (!this.componentData) return;
      return !!Object.keys(this.componentData)?.length;
    },
    disclaimerMessage() {
      return this.b2b
        ? this.$t('product.specification.disclaimer.B2B')
        : this.$t('product.specification.disclaimer.B2C');
    },
    weightMessage() {
      return this.isBike
        ? this.$t('product.specification.disclaimer.weight.bikes')
        : this.$t('product.specification.disclaimer.weight.aftermarket');
    },
    componentNames() {
      return this.componentData?.cmsComponents?.split(' ');
    },
    hasComponentProductData() {
      return this.componentNames?.length && this.product?.code;
    },
  },
  watch: {
    hasComponentProductData: {
      handler(value) {
        if (value) {
          this.fetchComponents(this.componentNames);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('productDetails', ['setProductSpecs']),

    async fetchComponents(components) {
      try {
        this.isLoadingSpecs = true;
        this.components = await CmsApi.getComponentsByIds(this.occUrlParams.userId, components);
      } catch (err) {
        console.error(err, 'An error occured retrieving components data.');
      } finally {
        this.isLoadingSpecs = false;
      }
    },
  },
};
</script>
